import React, { useContext, useEffect, useState } from 'react';
import './Styles.css';
import LoaderComponent from '../../Elements/ids/Loader';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';

const defaultUrl = '/';

const absoluteUrlToLocal = url => {
  if (url.startsWith(defaultUrl)) return url;
  return url.replace(new URL(url).origin, '');
};

const Callback = () => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const { isAuthenticated, isLoading, user, login } = useContext(AuthContext);

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        const storedUrl = sessionStorage.getItem('returnUrl');
        const redirectUrl = absoluteUrlToLocal(storedUrl || defaultUrl);
        sessionStorage.removeItem('returnUrl'); // Clean up storage
        setRedirectUrl(redirectUrl);
      } else {
        login();
      }
    }
  }, [isAuthenticated, isLoading, user, login]);

  if (isLoading) {
    return (
      <div className="callback-main">
        <LoaderComponent />
        <div className="callback-sub">
          <span>{formatMessage(Messages.common_redirecting)} ...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {!!redirectUrl && <Navigate push={false} to={redirectUrl} />}
      <div className="callback-main">
        <LoaderComponent />
        <div className="callback-sub">
          <span>{formatMessage(Messages.common_redirecting)} ...</span>
        </div>
      </div>
    </>
  );
};

export default Callback;
